<template>
  <transition name="modal" appear>
    <div class="modal modal-overlay">
      <div class="modal-window" v-click-outside="closeDialog">
        <div class="hw-modal-wrap modal-content">
          <div class="hw-modal-header">플러스앱 이전 안내</div>

          <div class="hw-modal-body">
            <p class="body-desc">
              2023년 2월 28일부터 (구)스토어에서 연동되었던 '페이존' 제휴서비스가 플러스앱으로 이전하여 제공합니다.
            </p>

            <div class="body-detail">
              <ul v-if="isAdmin">
                <li>1. '플러스앱'의 모든 플러스앱에서 '페이존' 클릭 후 '+가입신청' 버튼 클릭</li>
                <li>2. 이동한 '페이존' 사이트에서 재연동 진행</li>
                <li>3. SSO 연동 작업 완료 후 '사용공개' 버튼 클릭</li>
                <li>4. 업무 담당 직원 사용</li>
              </ul>

              <div v-else>
                플러스앱 이전을 위해서는 '오피스 관리자'가 '플러스앱'에서 새롭게 페이존의 연동 작업이 필요합니다.
                관리자에게 문의 바랍니다.
              </div>
            </div>
          </div>

          <div class="hw-modal-footer">
            <button type="button" :class="isAdmin ? 'hw-button secondary' : 'hw-button primary'" @click="closeDialog">
              {{ isAdmin ? $t('CANCEL') : '확인' }}
            </button>
            <a v-if="isAdmin" type="button" class="hw-button primary" @click="confirmDialog">
              플러스앱으로 이동
            </a>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'HUDDialog',
  props: {
    isAdmin: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    closeDialog() {
      this.$emit('close-dialog');
    },
    confirmDialog() {
      this.$emit('confirm-dialog');
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'src/assets/scss/style';

.hw-button {
  display: inline-block;
  background-color: $primary-color;
  border: 1px solid $primary-color-hover;
  border-radius: 4px;
  color: #fff;
  padding: 5px 20px 6px;
  font-size: 14px;
  line-height: 1.5;
  text-align: center;
  vertical-align: middle;
  transition-duration: 0.1s;
  user-select: none;
  white-space: nowrap;
  cursor: pointer;

  //hover
  &:hover,
  &:focus {
    color: #fff;
    background: darken($primary-color-hover, 10%);
    border-color: darken($primary-color-hover, 10%);
    outline: none;
  }

  //disabled
  &[disabled],
  &:disabled {
    cursor: default;
    opacity: 0.5;
    &:hover {
      background: $primary-color;
      border-color: $primary-color-hover;
    }
  }

  &.secondary {
    background-color: $secondary-color;
    border-color: $secondary-color-hover;
    color: #333;
    &:hover,
    &:focus {
      background-color: $secondary-color-hover;
      border-color: $secondary-color-hover;
    }
    //disabled
    &[disabled],
    &:disabled {
      &:hover {
        background: $secondary-color;
        border-color: $secondary-color-hover;
      }
    }
  }

  &.info {
    background-color: $info-color;
    border-color: $info-color-hover;
    color: #fff;
    &:hover,
    &:focus {
      background-color: $info-color-hover;
      border-color: $info-color-hover;
    }
    //disabled
    &[disabled],
    &:disabled {
      &:hover {
        background: $info-color;
        border-color: $info-color-hover;
      }
    }
  }

  &.warning {
    background-color: $warning-color;
    border-color: $warning-color-hover;
    color: #fff;
    &:hover,
    &:focus {
      background-color: $warning-color-hover;
      border-color: $warning-color-hover;
    }
    //disabled
    &[disabled],
    &:disabled {
      &:hover {
        background: $warning-color;
        border-color: $warning-color-hover;
      }
    }
  }

  &.danger {
    background-color: $danger-color;
    border-color: $danger-color-hover;
    color: #fff;
    &:hover,
    &:focus {
      background-color: $danger-color-hover;
      border-color: $danger-color-hover;
    }
    //disabled
    &[disabled],
    &:disabled {
      &:hover {
        background: $danger-color;
        border-color: $danger-color-hover;
      }
    }
  }

  &.text {
    color: $primary-color;
    padding: 0 10px;
    background: transparent;
    border-color: transparent;
    //hover
    &:hover,
    &:focus {
      color: $primary-color-hover;
    }
    //disabled
    &[disabled],
    &:disabled {
      &:hover {
        color: $primary-color;
        background: transparent;
        border-color: transparent;
        opacity: 0.5;
      }
    }
  }

  &.outline-blue {
    background-color: #fff;
    border: 1px solid #c8c8c8;
    color: #2c86dc;
    &:hover {
      border-color: #2c86dc;
    }
  }

  &.outline-gray {
    background: #f1f1f1;
    border: 1px solid #c8c8c8;
    color: #444;
    &:hover {
      border-color: #8c8c8c;
    }
  }

  &.outline-gray2 {
    background: #fff;
    border: 1px solid #d6d6d6;
    color: #333;
    padding-left: 12px;
    padding-right: 12px;
    > i {
      color: #909090;
      float: right;
      margin-top: 4px;
      margin-left: 10px;
    }
    &:hover {
      background: #f6f6f6;
    }
    &:focus {
      > i {
        color: #575757;
      }
    }
    &[disabled],
    &:disabled {
      border-color: #f2f2f2;
      background: #ffffff;
      &,
      > i {
        color: #d0d0d0;
      }
    }
  }

  &.rounded {
    border-radius: 4px;
  }

  //이웃하는 버튼 간격
  & + .hw-button {
    margin-left: 14px;
  }
}

.modal {
  &.modal-overlay {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    z-index: 30;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    box-sizing: border-box;
  }

  &-window {
    background: #fff;
    border-radius: 4px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    width: calc(100% - 20px);
    max-height: 80vh;
    max-width: 600px;

    @media (min-width: 900px) {
      width: 600px;
    }

    .hw-modal-wrap {
      width: 100%;
    }
  }

  &-content {
    padding: 10px 20px;
    overflow: auto;
  }

  &-footer {
    background: #ccc;
    padding: 10px;
    text-align: right;
  }
}

.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.2s;

  .modal-window {
    transition: opacity 0.2s, transform 0.2s;
  }
}

.modal-leave-active {
  transition: opacity 0.2s;
}

.modal-enter,
.modal-leave-to {
  opacity: 0;

  .modal-window {
    opacity: 0;
    transform: translateY(-20px);
  }
}

.hw-modal-header {
  padding-bottom: 20px;
  border-bottom: 1px solid #d6d6d6;
  font-size: 16px;
  font-weight: bold;
}

.hw-modal-body {
  padding-top: 20px;
  font-size: 14px;
  overflow-y: auto;
  letter-spacing: -0.28px;
  line-height: 24px;

  .body-desc {
    color: #131313;
    font-size: 14px;
  }

  .body-detail {
    margin-top: 23px;
    background-color: #f7f7f7;
    padding: 25px;
  }
}

.hw-modal-footer {
  padding-top: 30px;
  text-align: center;
}
</style>
